import { HTMLAttributes } from "react"

export default function MailerSend(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
    >
      <title>symbol</title>
      <g
        id="logo"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="symbol" fillRule="nonzero">
          <path
            d="M29.5793151,10.1663649 C29.4628886,9.99688216 29.2691772,9.90994232 29.0738683,9.90994232 L17.9522395,9.90994232 L23.498176,1.04527667 C23.6409633,0.817634197 23.6489514,0.506049814 23.4756097,0.256222694 C23.3579849,0.0865401142 23.1622765,0 22.9661687,0 L13.3890387,0 C12.4274714,0 11.5290101,0.515643175 10.9904126,1.3764475 L0.106230039,18.7748078 C-0.0361578035,19.0026502 -0.0421488768,19.3142345 0.129395522,19.5640617 C0.245622344,19.7333445 0.439333714,19.8200845 0.634842406,19.8200845 L11.7508795,19.8200845 L6.20434385,28.6869486 C6.10449263,28.846838 6.07393815,29.0480987 6.11947031,29.2399659 C6.18956587,29.5371603 6.45277369,29.7322253 6.73655086,29.7322253 L16.3080893,29.7322253 C17.2768458,29.7322253 18.182097,29.2125849 18.7244888,28.345385 L24.0563444,19.8200845 L24.0565441,19.8200845 L29.6020812,10.9554189 C29.7446688,10.7277764 29.7506598,10.4157923 29.5793151,10.1663649"
            id="Fill-1"
            fill="#4E48E0"
          ></path>
          <path
            d="M24.0576142,19.8181059 L18.7245604,28.3452051 C18.1821686,29.2126049 17.2767177,29.7320454 16.3081608,29.7320454 L6.73662243,29.7320454 C6.45284526,29.7320454 6.18963744,29.5371803 6.11954188,29.2399859 C6.07400973,29.0481187 6.1045642,28.846858 6.20441542,28.6869686 L11.7519496,19.8181059 L24.0576142,19.8181059 Z"
            id="Fill-3"
            fill="#4E48E0"
          ></path>
          <path
            d="M17.9450419,9.90992233 L29.0738599,9.90992233 C29.2691689,9.90992233 29.4628803,9.99686217 29.5793068,10.166145 C29.7508512,10.4157723 29.7444608,10.7275565 29.6022726,10.9553989 L24.0567355,19.8200645 L11.746278,19.8200645 L17.9450419,9.90992233 Z"
            id="Fill-5"
            fill="#1C81C1"
          ></path>
          <path
            d="M0.634794157,19.8200445 C0.439485167,19.8200445 0.245773797,19.7333046 0.129546975,19.5640217 C-0.0421971263,19.3141946 -0.036206053,19.0026102 0.106381492,18.7749677 L10.9905641,1.37640753 C11.5289618,0.515603203 12.4276228,-3.99723392e-05 13.3889904,-3.99723392e-05 L22.9661205,-3.99723392e-05 C23.1622283,-3.99723392e-05 23.3581364,0.0867000036 23.4757611,0.256182722 C23.6489031,0.506009841 23.640915,0.817594225 23.4983275,1.04543656 L11.7520295,19.8200445 L0.634794157,19.8200445 Z"
            id="Fill-7"
            fill="#5CC4CD"
          ></path>
        </g>
      </g>
    </svg>
  )
}
